var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExpenses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    "aria-label": "Expenses",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 20.8538C10.285 20.8538 9.58831 20.4872 9.11165 19.8455L8.18581 18.608C7.99331 18.3513 7.73665 18.2047 7.46165 18.1863C7.18665 18.1772 6.91165 18.2963 6.69165 18.5255L6.16915 18.058L6.67331 18.5255C5.35331 19.9372 4.33581 19.8272 3.84998 19.6347C3.35498 19.4422 2.52081 18.8097 2.52081 16.7747V6.45301C2.52081 2.38301 3.69415 1.14551 7.53498 1.14551H14.465C18.3058 1.14551 19.4791 2.38301 19.4791 6.45301V16.7747C19.4791 18.8005 18.645 19.433 18.15 19.6347C17.6641 19.8272 16.6558 19.9372 15.3266 18.5255C15.1066 18.2872 14.8408 18.1588 14.5475 18.1863C14.2725 18.2047 14.0066 18.3513 13.8141 18.608L12.8883 19.8455C12.4116 20.4872 11.715 20.8538 11 20.8538ZM7.40665 16.8022C7.44331 16.8022 7.48915 16.8022 7.52581 16.8022C8.20415 16.8388 8.84581 17.1963 9.27665 17.7738L10.2025 19.0113C10.6516 19.6072 11.3391 19.6072 11.7883 19.0113L12.7141 17.7738C13.1541 17.1963 13.7866 16.8388 14.4741 16.8022C15.1525 16.7655 15.8308 17.0497 16.3258 17.5813C17.0225 18.3238 17.4808 18.4155 17.6366 18.3513C17.8566 18.2597 18.095 17.728 18.095 16.7747V6.45301C18.095 3.14384 17.5175 2.52051 14.4558 2.52051H7.53498C4.47331 2.52051 3.89581 3.14384 3.89581 6.45301V16.7747C3.89581 17.7372 4.13415 18.2688 4.35415 18.3513C4.50998 18.4155 4.96831 18.3238 5.66498 17.5813C6.15998 17.0772 6.77415 16.8022 7.40665 16.8022Z",
    fill: "#525252"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 7.10449H7.33331C6.95748 7.10449 6.64581 6.79283 6.64581 6.41699C6.64581 6.04116 6.95748 5.72949 7.33331 5.72949H14.6666C15.0425 5.72949 15.3541 6.04116 15.3541 6.41699C15.3541 6.79283 15.0425 7.10449 14.6666 7.10449Z",
    fill: "#525252"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 10.7705H8.25C7.87417 10.7705 7.5625 10.4588 7.5625 10.083C7.5625 9.70717 7.87417 9.39551 8.25 9.39551H13.75C14.1258 9.39551 14.4375 9.70717 14.4375 10.083C14.4375 10.4588 14.1258 10.7705 13.75 10.7705Z",
    fill: "#525252"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpenses);
export default __webpack_public_path__ + "static/media/expenses.8a8935fe66d5d196069951c723ba5946.svg";
export { ForwardRef as ReactComponent };